import * as MT from "./mutationTypes";

export default {
  [MT.SET_USER]: (state, data) => (state.user = data),
  [MT.UPDATE_USER_NAME]: (state, data) => (state.user.name = data.value),
  [MT.SET_GLOBAL_TIME_PERIOD]: (state, data) => {
    state.globalTimePeriod = data;
    state.user.timePeriod = data;
  },
  [MT.GET_GLOBAL_TIME_PERIOD_FROM_STORAGE]: (state, globalTimePeriod) => {
    if (state.globalTimePeriod === null) {
      return (state.globalTimePeriod = globalTimePeriod.timePeriod);
    }
    return state.globalTimePeriod;
  }
};
